<template lang="pug">
.mt-n5
  server-data(
    :method="$api.mentoring.getCategories"
    :query="query"
    search-field-name="search[name]"
    @init="resetQuery"
    v-slot="{ selectProps, search, loadMoreItems, loading }"
  )
    v-autocomplete-more(
      v-model="inputValue"
      v-bind="{ ...selectProps, ...$attrs }"
      :search-input.sync="searchInput"
      :loading="loading"
      label="Выберите категории"
      filled
      multiple
      rounded
      cache-items
      item-text="name"
      item-value="id"
      @update:search-input="search"
      @load-more-items="loadMoreItems"
    )
      template(#selection="{ item, index }")
        v-chip(
          color="primary"
          small label
        ) {{ item.name }}

</template>
<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchInput: null,
      query: { 'search[id]': this.value?.map((id) => id) },
      menu: false,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    resetQuery() {
      this.query = {};
    },
  },
};
</script>
